import "../App.css";
import { Button, Col, Container, Form } from "react-bootstrap";
import { optionsArray } from "../helpers/hardCodedData";
import {
  BriefcaseFill,
  BuildingFill,
  EnvelopeAt,
  GeoAltFill,
  GlobeAmericas,
  Map,
  PeopleFill,
  PersonPlusFill,
  Send,
  ShieldFillCheck,
  TelephoneInbound,
} from "react-bootstrap-icons";
import useRegister from "../hooks/useRegister";
import ToastComponent from "../components/ToastComponent";

const Register = ({ user }) => {
  const {
    handleSubmit,
    setVendor,
    setShowToast,
    showToast,
    vendor,
    actionState,
    submitted,
  } = useRegister(user);

  return (
    <Container
      fluid
      className="col-lg-12 col-sm-12 px-5 custom-pry-color"
      style={{ paddingTop: "160px" }}
    >
      <h1 className="fs-3 fw-bold">Add Business</h1>
      <p className="custom-pry-text">
        Register new business to feature on marketplace
      </p>
      <div className="py-3 d-flex justify-content-center shadow-sm p-4 mb-5 rounded-2 col-xxl-6 col-lg-6">
        <Form
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          className="gap-3 vstack"
        >
          <Form.Group>
            <Form.Label htmlFor="businessID">
              <ShieldFillCheck /> Business ID:
            </Form.Label>
            <Form.Control
              type="number"
              className="rounded-0"
              value={vendor.businessID}
              id="businessID"
              name="businessID"
              onChange={(e) =>
                setVendor({ ...vendor, businessID: e.target.value })
              }
              disabled
            />
          </Form.Group>
          <Form.Group>
            {" "}
            <Form.Label htmlFor="firstName">
              <PersonPlusFill /> First Name:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="firstName"
              name="firstName"
              minLength={1}
              maxLength={50}
              spellCheck="false"
              autoCapitalize="on"
              value={vendor.firstName}
              onChange={(e) =>
                setVendor({ ...vendor, firstName: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="lastName">
              <PeopleFill /> Last Name:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="lastName"
              name="lastName"
              minLength={1}
              maxLength={50}
              spellCheck="false"
              autoCapitalize="on"
              value={vendor.lastName}
              onChange={(e) =>
                setVendor({ ...vendor, lastName: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group>
            {" "}
            <Form.Label htmlFor="businessName">
              <BuildingFill /> Business Name:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="businessName"
              name="businessName"
              minLength={1}
              maxLength={50}
              spellCheck="false"
              autoCapitalize="on"
              value={vendor.businessName}
              onChange={(e) =>
                setVendor({ ...vendor, businessName: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="category">
              <BriefcaseFill /> Category:
            </Form.Label>
            <Form.Select
              id="category"
              className="rounded-0 shadow-sm border-0 bg-white-subtle"
              required
              value={vendor.category}
              onChange={(e) =>
                setVendor({ ...vendor, category: e.target.value })
              }
            >
              <option>Please select</option>
              {optionsArray.map((item, index) => (
                <option key={index}>{item}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            {" "}
            <Form.Label htmlFor="address">
              <GeoAltFill /> Address:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="address"
              name="address"
              minLength={1}
              maxLength={50}
              spellCheck="false"
              autoCapitalize="on"
              value={vendor.address}
              onChange={(e) =>
                setVendor({ ...vendor, address: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group>
            {" "}
            <Form.Label htmlFor="city">
              <GlobeAmericas /> City:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="city"
              name="city"
              minLength={1}
              maxLength={50}
              spellCheck="false"
              autoCapitalize="on"
              value={vendor.city}
              onChange={(e) => setVendor({ ...vendor, city: e.target.value })}
            />
          </Form.Group>
          <Form.Group>
            {" "}
            <Form.Label htmlFor="state">
              <Map /> State:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="state"
              name="state"
              minLength={1}
              maxLength={50}
              spellCheck="false"
              autoCapitalize="on"
              value={vendor.state}
              onChange={(e) => setVendor({ ...vendor, state: e.target.value })}
            />
          </Form.Group>
          <Form.Group>
            {" "}
            <Form.Label htmlFor="email">
              <EnvelopeAt /> Email:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="email"
              name="email"
              minLength={1}
              maxLength={50}
              spellCheck="false"
              value={vendor.email}
              onChange={(e) => setVendor({ ...vendor, email: e.target.value })}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="businessPhone">
              <TelephoneInbound /> Business Phone:
            </Form.Label>
            <Form.Control
              type="text"
              className="rounded-0"
              required
              id="businessPhone"
              name="businessPhone"
              size={11}
              value={vendor.businessPhone}
              onChange={(e) =>
                setVendor({ ...vendor, businessPhone: e.target.value })
              }
            />
          </Form.Group>

          <Col className="hstack gap-2">
            <Button
              size="sm"
              type="submit"
              className="custom-pry rounded-1 custom-pry-border text-light"
              disabled={Object.values(vendor).every((el) => !el)}
            >
              <Send /> Submit
            </Button>
            <input
              title="Reset"
              type="reset"
              className="btn btn-sm bg-transparent border rounded-1"
              onClick={() => setVendor("")}
            />
          </Col>
        </Form>
      </div>
      {submitted === true && actionState.status === 200 ? (
        <ToastComponent
          message={"Successfully submitted"}
          show={showToast}
          onClose={() => setShowToast(false)}
        />
      ) : submitted === true && actionState.status === 500 ? (
        <ToastComponent
          message={"Submission failed"}
          show={showToast}
          onClose={() => setShowToast(false)}
        />
      ) : submitted === true && Object.values(vendor).some((v) => !v) ? (
        <ToastComponent
          message={"Form cannot be empty"}
          show={showToast}
          onClose={() => setShowToast(false)}
        />
      ) : null}
    </Container>
  );
};

export default Register;
